import { useEffect } from "react";
import { dispatch } from "../App";
import { actions } from "../redux";
import type { appConfig } from "../system/types/app/appConfig";
import { initalAppConfig } from "../system/config/appConfig";

const useEnv = () => {

    useEffect(() => {
        const appConfig:appConfig = initalAppConfig;

        appConfig.apiKey = process.env.REACT_APP_API_KEY ?? '';
        appConfig.apiUrl = process.env.REACT_APP_API_URL ?? '';
        appConfig.language = process.env.REACT_APP_DEFAULT_LANGUAGE ?? '';

        dispatch(actions.system.setAppConfig(appConfig));
        dispatch(actions.system.setInitDone(true));

    }, []);
};

export { useEnv };
